import React from 'react';
import Component from '@vfuk/core-gallery';
const Gallery = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default Gallery;
